import { API } from '~apis/axios/instance';
import { CompanyModel } from '~models/company';
import { ResponseBaseWithData } from '~types/response';

export const verifyCompany = (request: CompanyModel.VerifyCompanyRequest) => {
  return API.post<ResponseBaseWithData<CompanyModel.VerifyCompanyResponse>>(
    '/api/v3/companies/check-identity',
    {
      data: request,
    },
  );
};
